import React, { DragEventHandler, useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import LayoutField from "../Components/LayoutField";
import BackgroundGraphicControl from "../Components/BackgroundGraphicControl";
import { FormConfig, SelectListOption } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemSearchResult from '../../../models/ItemSearchResult';
import DataService from "../../../services/data.service";
import { DataResult, Result } from "../../../types/Result";
import ColorPickerField from "../../../components/Fields/ColorPickerField";
import Field from "../../../components/Fields/Field";
import TextareaField from "../../../components/Fields/TextareaField";
import ProductCategoryModel from "../../../models/ProductCategoryModel";
import { Col, Container, Row } from "react-bootstrap";

interface PopupProps {
    show: boolean
    onHide: () => void
    selectedItemIds: number[]
    //selectedItems: ItemSearchResult[]
}

interface Page {
    pageNumber: number
    pageItems: ItemSearchResult[]
}

interface SalesPresentationModel {
    items: string
    itemModels: ItemSearchResult[]
    title?: string
    itemsPageLayout: number
    backgroundColor?: string
    logoFile?: string

    coverPage: boolean
    coverPageBackgroundItemId? : number
    productCategoryIdCoverPage? : number

    storyPage: boolean
    storyPageBackgroundItemId?: number
    productCategoryIdStoryPage?: number

    itemsPage: boolean
    itemsPageBackgroundItemId?: number
    productCategoryIdItemsPage?: number

    backPage: boolean
    backPageBackgroundItemId?: number
    productCategoryIdBackPage?: number

    additionalText1?: string
    additionalText2?: string
    coverStory?: string

    //[Display(Name = "Add extra logo")]
    //public File LogoFile { get; set; }

}

const SalesPresentationPopup: React.FC<PopupProps> = ({ show, onHide, selectedItemIds }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const [salesPresentationBackgroundProductCategoryId, setSalesPresentationBackgroundProductCategoryId] = useState<number>();
    const projects = useSelectListOptions('api/v1/selectlist/Projects?activeOnly=true', '-- Select project');
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<SalesPresentationModel>({
        items: selectedItemIds.join(','),
        itemModels: [],
        itemsPageLayout: 0,
        coverPage: true,
        storyPage: true,
        itemsPage: true,
        backPage: true,
    });

    const additionalTextTypes: SelectListOption[] = [
        { value: '1', label: 'Status' },
        { value: '2', label: 'Name' },
        { value: '3', label: 'Designer' },
        { value: '4', label: 'Owner' },
        { value: '5', label: 'Project' },
        { value: '6', label: 'Category' },
        { value: '7', label: 'Brand' },
        { value: '8', label: 'Supplier' },
        { value: '9', label: 'Licensor' },
    ]

    useEffect(() => {
        formData.items = selectedItemIds.join()
        setFormData(formData)
        getItemModels()
    }, [selectedItemIds])

    useEffect(() => {
        DataService
            .get<DataResult<ProductCategoryModel>>(`api/v1/ProductCategories/ForSalesPresentation`)
            .then(response => {
                handleResult(response);
                if (response.isSuccesful === true && response.data) {
                    setSalesPresentationBackgroundProductCategoryId(response.data.id)
                }
            })
            .catch(e => handleException(e));
    }, [])

    function getItemModels() {
        DataService
            .post<ItemSearchResult[]>(`api/v1/ItemRevisions/ForSalesPresentation`, selectedItemIds)
            .then(response => {
                formData.itemModels = response
                setFormData(x => ({...formData}))
            })
            .catch(e => handleException(e));
    }

    function submit() {
        if (formData) {
            //const url = `api/v1/ItemAttachments/SalesPresentation?billOfMaterialsId=${formData.billOfMaterialsId}&attachmentTypeId=${formData.attachmentTypeId}&language=${formData.language}&documentOutputTypeId=${formData.documentOutputTypeId}&outputOptions=${formData.outputOptions}`
            DataService
                .postFile(`api/v1/DocumentGeneration/SalesPresentation`, formData)
                .then(response => {
                    const url = window.URL.createObjectURL(response);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', formData.title + '.pdf');
                    document.body.appendChild(link);
                    link.click();
                })
/*
            DataService
                .post<SalesPresentationModel>(`api/v1/DocumentGeneration/SalesPresentation`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
                */
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'title', label: 'Title' },
            { name: 'itemsPageLayout', label: 'Layout', validationRules: [{ type: 'isRequired' }] },
            { name: 'backgroundColor', label: 'Color' },
            { name: 'logoFile', label: 'Logo' },
            { name: 'coverPageBackgroundItemId', label: 'Coverpage' },
            { name: 'storyPageBackgroundItemId', label: 'Storypage' },
            { name: 'itemsPageBackgroundItemId', label: 'Itemspage' },
            { name: 'backPageBackgroundItemId', label: 'Backpage' },
            { name: 'additionalText1', label: 'Additional text 1'},
            { name: 'additionalText2', label: 'Additional text 2' },
            { name: 'coverStory', label: 'Coverstory'},

        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    function GetItemsPerPage() {
        switch (formData.itemsPageLayout) {
            case 1: return 6;
            case 2: return 1;
            case 3: return 3;
            case 4: return 3;
            case 5: return 3;
        }
        return 100000;
    }

    function getItems() {

        var pageSize = GetItemsPerPage();
        var pageItemCount = 0;
        var pageCount = 0;

        var pageItems: Page[] = []

        for (var i = 0; i < formData.itemModels.length; i++) {
            var model = formData.itemModels[i]
            model['_index'] = i

            if (pageItemCount == 0)
                pageItems[pageCount] = {
                    pageNumber: pageCount + 1,
                    pageItems: []
                }

            pageItems[pageCount].pageItems.push(model)
            pageItemCount++

            if (pageItemCount == pageSize) {
                pageItemCount = 0
                pageCount++
            }
        }

        return pageItems.map((item, pageIndex) => {
            return <>
                <div>
                    {item.pageItems.map((item, itemIndex) => 
                        <img id={`img_${item['_index']}`} src={item.imageUrl} draggable="true" onDragStart={drag} onDragOver={dragOver} onDragLeave={dragLeave} onDrop={drop} style={{ margin: 5, width: 64 }} />
                    )}
                </div>
                <hr />
            </>
        })
    }

    function dragOver(ev) {
        ev.preventDefault();
        ev.target.style.borderLeft = "thick solid #00BCD4";
    }

    function dragLeave(ev) {
        ev.preventDefault();
        ev.target.style.borderLeft = "";
    }

    function drop(ev: React.DragEvent<HTMLImageElement>) {
        var dataDragTarget = parseInt(ev.dataTransfer.getData("id").slice(4));
        var dataDropTarget = parseInt(ev.target['id'].slice(4));


        var dragItem = formData.itemModels.splice(dataDragTarget, 1)[0];
        if (dataDropTarget < dataDragTarget)
            formData.itemModels.splice(dataDropTarget, 0, dragItem);
        else
            formData.itemModels.splice(dataDropTarget - 1, 0, dragItem);

        formData.items = formData.itemModels.map(item => item.itemRevisionId).join(',');

        setFormData({ ...formData })
    }

    function drag(ev) {
        ev.dataTransfer.setData("id", ev.target.id);
    }

    const { getControlProps, getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    if (!salesPresentationBackgroundProductCategoryId)
        return null

    return (
        <Popup show={show} onHide={onHide} size={'xl'} title={'Generate sales presentation'} >
            <Popup.Body>
                <Container>
                    <Row>
                        <Col>
                            <TextboxField {...getFieldProps('title')} />
                            <LayoutField  {...getFieldProps('itemsPageLayout')} />
                            <ColorPickerField {...getFieldProps('backgroundColor')} />
                            <Field text='Background graphics' labelSize={2} required={false}>
                                <BackgroundGraphicControl {...getControlProps('coverPageBackgroundItemId')} label='Cover page' salesPresentationBackgroundProductCategoryId={salesPresentationBackgroundProductCategoryId}/>
                                <BackgroundGraphicControl {...getControlProps('storyPageBackgroundItemId')} label='Story page' salesPresentationBackgroundProductCategoryId={salesPresentationBackgroundProductCategoryId}/>
                                <BackgroundGraphicControl {...getControlProps('itemsPageBackgroundItemId')} label='Background' salesPresentationBackgroundProductCategoryId={salesPresentationBackgroundProductCategoryId}/>
                                <BackgroundGraphicControl {...getControlProps('backPageBackgroundItemId')} label='Backpage' salesPresentationBackgroundProductCategoryId={salesPresentationBackgroundProductCategoryId}/>
                            </Field>
                            <SelectListField {...getFieldProps('additionalText1')} options={additionalTextTypes} />
                            <SelectListField {...getFieldProps('additionalText2')} options={additionalTextTypes} />
                            <TextareaField {...getFieldProps('coverStory')} />
                        </Col>
                        <Col>
                            {getItems()}
                        </Col>
                    </Row>
                </Container>
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Generate' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default SalesPresentationPopup;